module.exports = __webpack_public_path__ + "static/media/more.89fd9fe8.svg";